var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlechaabajo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.748,
    height: 6.594,
    viewBox: "0 0 10.748 6.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21686",
    "data-name": "Group 21686",
    transform: "translate(-223.586 -6.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72713",
    "data-name": "Path 72713",
    d: "M1254.031,2118.717l4.065,4.18,3.855-4.18",
    transform: "translate(-1029.031 -2110.807)",
    fill: "none",
    stroke: "#0e0233",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidt: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaabajo);
export default __webpack_public_path__ + "static/media/flechaabajo.c7c79c125a7ea2146d561ed7a4c46689.svg";
export { ForwardRef as ReactComponent };